import { Injectable } from '@angular/core';
import { HttpService } from '../services/http.service';
import { WeatherCondition } from "./weather.model";
import { Observable } from "rxjs";

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class WeatherApiService {
  constructor(private http: HttpService) {}

  public getWeatherConditions(locationNames: string[]): Observable<WeatherCondition[]> {
    locationNames = locationNames.map(l => l.replace(/,/gi, ":"))
    const url = `${apiBaseUrl}/v1/data/weather?locationNames=${locationNames}`;

    return this.http.get<WeatherCondition[]>(url);
  }
}
